import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import {packingStepNames} from "../../../packingSteps";
import {Grid} from "@mui/material";
import CustomButton from "../../../../../../../../components/CustomButton";
import {FormattedMessage} from "react-intl";
import {PackingContext} from "../../../PackingContext";
import BottomDrawer from "../../../../../../../../components/WMS/Mobile/BottomDrawer";
import {WMSContext} from "../../../../../../context/WMSContext";
import {grey300} from "../../../../../../../../assets/jss/main";
import {ReactComponent as MenuIcon} from "assets/img/wms/more.svg"

MultiExpeditonSessionMoreDrawer.propTypes = {

};

function MultiExpeditonSessionMoreDrawer({fullWidth = false}) {
    const {packingLoading, setIsMultiSessionPacking, nextShipment} = useContext(PackingContext)
    const {isMobile} = useContext(WMSContext)

    const [openDrawer, setOpenDrawer] = useState(false)


    if (openDrawer) {
        return (
            <BottomDrawer
                open={openDrawer}
                onClose={() => setOpenDrawer(false)}
                openMaxHeight
                maxHeight={"30%"}
                title={<FormattedMessage id={'wms.packing.drawer.multiExpSession.title'}/>}
            >
                <Grid
                    container
                    direction={"column"}
                    flexWrap={"nowrap"}
                    gap={"8px"}
                    sx={{padding: isMobile ? "8px" : "16px"}}
                >
                    <CustomButton
                        fullWidth
                        onClick={() => nextShipment()}
                        disabled={packingLoading}
                    >
                        <FormattedMessage id={"wms.packing.item.multiExpSession.nextShipment"}/>
                    </CustomButton>
                    <CustomButton
                        fullWidth
                        color={"lightRed"}
                        variant={'nude'}
                        onClick={() => setIsMultiSessionPacking(false)}
                        disabled={packingLoading}
                    >
                        <FormattedMessage id={"wms.packing.item.multiExpSession.stopSession"}/>
                    </CustomButton>
                </Grid>
            </BottomDrawer>
        )
    }

    return (
        <CustomButton
            onClick={() => setOpenDrawer(true)}
            fullWidth={fullWidth}
            color={"idle"}
        >
            <MenuIcon />
        </CustomButton>
    );
}

export default MultiExpeditonSessionMoreDrawer;